function slider() {
 let sliders = document.querySelectorAll('.slider');
 if (sliders.length > 0) {
  for (let i = 0; i < sliders.length; i++) {
   let slider = sliders[i].querySelector('.slider-container');
   let sliderList = slider.querySelector('.slider-list');
   let sliderItem = sliderList.querySelectorAll('LI');
   let sliderItemWidth = sliderList.querySelector('LI').getBoundingClientRect().width + 10;
   let prev = slider.querySelector('.prev');
   let next = slider.querySelector('.next');
   let currentSlide = 0;
   let laptopQuery = window.matchMedia('(min-width: 581px) and (max-width: 980px)');
   let mobileQuery = window.matchMedia('(max-width: 580px)');

   function countSlide() {
    if (laptopQuery.matches) {
     return 3;
    } else if (mobileQuery.matches) {
     sliderItemWidth = sliderList.querySelector('LI').getBoundingClientRect().width
     return 1;
    } else {
     return 5;
    }
   }

   function moveSlide() {
    sliderList.style.transform = `translateX(${-sliderItemWidth * currentSlide}px)`;
   }

   next.addEventListener('click', (e) => {
    e.preventDefault();
    currentSlide++;

    if (currentSlide > sliderItem.length - countSlide()) {
     currentSlide = 0;
    }

    moveSlide()
   })

   prev.addEventListener('click', (e) => {
    e.preventDefault();
    currentSlide--;

    if (currentSlide < 0) {
     currentSlide = sliderItem.length - countSlide();
    }

    moveSlide()
   })
  }
 }
}
slider()